(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sun-exposure", [], factory);
	else if(typeof exports === 'object')
		exports["sun-exposure"] = factory();
	else
		root["sun-exposure"] = factory();
})(self, function() {
return 